import React from 'react'
import clientLogo from '../../assets/client_logo.png'
import { Link } from 'react-router-dom'
const Video = () => {
  return (
    <div className='bg-[#0E1629] pb-10'>
        <div>
            <div className='grid md:grid-cols-2 gap-5 rounded-md border border-[#2A3343] p-10'>
                <div>
                    <img width="100" src={clientLogo} alt="" />
                    <p className='text-gray-400 text-lg'>I am happy to share my positive feedback from my time at Rihisi Company as a Front End Developer. My boss has commended my exceptional commitment, creativity, and proficiency in delivering high-quality work. I am thrilled to contribute to the team's success and appreciate the constructive feedback that has motivated me to excel further. The collaborative environment and challenging projects at Rihisi have truly enhanced my professional growth.</p>
                    <Link target='_blank' to={'https://rihisi.com'} className='text-white btn bg-[#22d3ee] hover:bg-[#22d3gg] px-10 rounded-md mt-5 hover:bg-[#22d3ee] capitalize'>Visit Rihisi</Link>
                </div>
                <div className='ring-2 ring-[#22d3ee] rounded-md p-2'>
                    <iframe width="100%" height="315" src="https://www.youtube.com/embed/8J821ZBjw7M?si=m6V1Or3OIt8gIxJd" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Video